import {
  Avatar, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText,
} from '@mui/material';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import CircleTwoToneIcon from '@mui/icons-material/CircleTwoTone';
import React, { MouseEventHandler, ReactElement } from 'react';
import { LinkedRecord } from '../shared/material_components/linked-cell';

interface Props {
  issue: LinkedRecord,
  onClick?: (issue: LinkedRecord) => void,
}

function statusIcon(status?: string|null): ReactElement {
  if (status === 'Resolved') {
    return <CheckCircleTwoToneIcon color="success" />;
  }
  return <CircleTwoToneIcon color="info" />;
}

const IssueLink: React.FC<Props> = ({ issue, onClick = () => {} }) => {
  const handleClick = (e: MouseEventHandler<HTMLLIElement>) => {
    // @ts-ignore
    e.preventDefault();
    onClick(issue);
  };

  return (
    // @ts-ignore
    <ListItem onClick={handleClick} disablePadding>
      <ListItemButton sx={{ padding: '8px 0px' }}>
        <ListItemAvatar>
          <Avatar alt={issue.created_by} src={`/users/${issue.created_by_id}/avatar`} />
        </ListItemAvatar>
        <ListItemText primary={issue.form_values.b392} secondary={`${issue.status}, Reported by ${issue.created_by}`} />
        <ListItemIcon sx={{ padding: '0px 0px 0px 20px', minWidth: 'unset' }}>
          {statusIcon(issue.status)}
        </ListItemIcon>
      </ListItemButton>
    </ListItem>
  );
};

export default IssueLink;
